module.exports = __webpack_public_path__ + "img/img_x.48e7ef46.png";